module.exports = __webpack_public_path__ + "static/img/CarbonFootprint1.488242de.png";